import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "plan-content" }
const _hoisted_2 = {
  id: "make-co-payment-form",
  class: "form make-co-payment",
  method: "post"
}
const _hoisted_3 = { class: "inputs-wrapper" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"bordered-card\"><div class=\"bordered-card-header\"><small> Selected Coverage </small></div><div class=\"bordered-card-body\"><h4> Plan C2 Single </h4><div class=\"divider\"></div><div class=\"bordered-card green-card\"><h6> Amount Owned</h6><h4> $ 1,086.00 </h4></div><a class=\"btn btn-primary\"> Change Coverage </a></div></div>", 1)
const _hoisted_5 = { class: "action-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlanGeneral = _resolveComponent("PlanGeneral")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_DateInput = _resolveComponent("DateInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PlanGeneral, { text: "You can select a coverage option from any of the option shown below. Even if you do not owe a co-payment for the co-payment for the coverage you are selecting, you must complete the process by clicking  the “Select this Coverage” button. Your Payment is due 12/23/2012 for the coverage period starting 01/01/2013." }),
    _createElementVNode("form", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TextInput, {
          type: "text",
          label: "Card Type",
          placeholder: "Enter here",
          max: 25,
          modelValue: _ctx.formData.cardType,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.cardType) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_TextInput, {
          type: "text",
          label: "Cardholder Name",
          placeholder: "Enter here",
          max: 25,
          modelValue: _ctx.formData.cardholder,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.cardholder) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_TextInput, {
          type: "text",
          label: "Card Number",
          placeholder: "Enter here",
          max: 19,
          customClass: "card-number-input",
          modelValue: _ctx.formData.cardNumber,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.cardNumber) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_DateInput, {
          label: "Card Expiration Date",
          modelValue: _ctx.formData.expirationDate,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.expirationDate) = $event)),
          pattern: "MM/YY",
          icon: false
        }, null, 8, ["modelValue"]),
        _createVNode(_component_TextInput, {
          type: "text",
          label: "CVV",
          placeholder: "XXX",
          max: 3,
          customClass: "cvv",
          modelValue: _ctx.formData.cvv,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.cvv) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          href: "",
          class: "btn btn-secondary plan-modal",
          onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["prevent"]))
        }, " Cancel "),
        _createElementVNode("a", {
          href: "",
          class: "btn btn-primary plan-modal",
          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.openModal('success-modal', null, 'modal-success', null, _ctx.props)), ["prevent"]))
        }, " Submit ")
      ])
    ])
  ]))
}